import { useEffect, useState } from "react"
import { previewBankAccountFiling } from "../../ApiInterface"
import { useFilingConfirmation } from "./FilingModal"

interface Props {
    bankAccount: BankAccount
    onSave: (params: BankAccountParams) => Promise<unknown>
    onError: (fallback: string) => (e: any) => void
}

const MODE_TITLES: Record<FilenameMode, string> = {
    card_statement: 'par mois de débit',
    monthly: 'par mois',
    fixed: 'dans un seul relevé'
}

const BankAccountRow = (props: Props) => {
    const { bankAccount, onSave, onError } = props
    const { confirm, modal } = useFilingConfirmation()

    const [fixedFilename, setFixedFilename] = useState(bankAccount.fixed_filename || '')

    useEffect(() => {
        setFixedFilename(bankAccount.fixed_filename || '')
    }, [bankAccount])

    const changed = fixedFilename !== (bankAccount.fixed_filename || '')

    // Changer de rangement re-range l'historique du compte : aperçu, puis confirmation.
    const saveFiling = (params: BankAccountParams) => {
        const mode = params.filename_mode || bankAccount.filename_mode
        previewBankAccountFiling(bankAccount.id, params)
            .then((preview) => confirm(`Ranger « ${bankAccount.name} » ${MODE_TITLES[mode]}`, preview, () => onSave(params)))
            .catch(onError('Impossible de calculer le nouveau rangement'))
    }

    return <tr className={bankAccount.enabled ? '' : 'disabled'}>
        <td className="enabled">
            { modal }
            <label className="switch" title={bankAccount.enabled ? 'Importé' : 'Non importé'}>
                <input type="checkbox" checked={bankAccount.enabled} onChange={(e) => onSave({enabled: e.target.checked})}/>
                <span/>
            </label>
        </td>
        <td className="name">{ bankAccount.name }</td>
        <td>
            <div className="filing">
                <select className="tl-select" value={bankAccount.filename_mode} onChange={(e) => saveFiling({filename_mode: e.target.value as FilenameMode})}>
                    <option value="card_statement">Par mois de débit (carte)</option>
                    <option value="monthly">Par mois</option>
                    <option value="fixed">Un seul relevé</option>
                </select>
                { bankAccount.filename_mode === 'fixed' &&
                    <input className="tl-input" placeholder="Nom du relevé" value={fixedFilename} onChange={(e) => setFixedFilename(e.target.value)}/> }
                { changed && <button className="tl-btn tl-btn-secondary" onClick={() => saveFiling({fixed_filename: fixedFilename})}>OK</button> }
            </div>
        </td>
    </tr>
}

export default BankAccountRow
